import { Close, ErrorOutline } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";

type RejectDocumentDialogProps = {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
};

const RejectDocumentDialog = ({ open, loading = false, onClose, onConfirm }: RejectDocumentDialogProps) => {
  const [reason, setReason] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (!open) {
      setReason('');
      setSubmitted(false);
    }
  }, [open]);

  const trimmedReason = reason.trim();
  const showError = submitted && trimmedReason.length === 0;

  const handleConfirm = () => {
    setSubmitted(true);
    if (!trimmedReason) {
      return;
    }

    onConfirm(trimmedReason);
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <ErrorOutline color="error" />
          <Typography variant="h6">Refuser le document</Typography>
        </Stack>
        <IconButton onClick={onClose} disabled={loading}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
          Vous êtes sur le point de refuser ce document. Veuillez indiquer la raison du refus.
        </Typography>
        <TextField
          label="Raison du refus *"
          fullWidth
          multiline
          minRows={4}
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          error={showError}
          helperText={showError ? 'La raison du refus est obligatoire.' : ' '}
          placeholder="Ex : Document illisible, informations incohérentes, document expiré..."
          disabled={loading}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button variant="outlined" onClick={onClose} disabled={loading}>Annuler</Button>
        <Button variant="contained" color="error" onClick={handleConfirm} disabled={loading}>Confirmer le refus</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectDocumentDialog;
